import React from 'react';
import {Button, Box} from '@mui/material';

const styles = {
    buttonBox: {
        width: "100%",
        marginBottom: 1
    }
}

export default function Choice(props) {

    const {options, makeAnswered, lang} = props;

    const renderButtons = () => {

        const buttons = [];

        for (const option of options) {
            buttons.push(
                <Box key={option.value[lang]} sx={styles.buttonBox}>
                    <Button onClick={() => makeAnswered(option.correct)}
                        color="secondary" variant="contained" size="small"
                        sx={{
                            width: "60%"
                        }}
                    >{option.value[lang]}</Button>
                </Box>
            )
        }

        return buttons;
    }

    return (
        <Box>
            {renderButtons()}
        </Box>
    )
}